import styled from "@emotion/styled";
import { Chip, useMediaQuery } from "@mui/material";

interface ProfileListItemProps {
	text?: string;
	title: string;
	notChip?: boolean;
	dark?: boolean;
	link?: boolean;
	invisibleOption?: boolean;
	topAlign?: boolean;
}

const ProfileListItem = (props: ProfileListItemProps) => {
	const { text, title, notChip, link, invisibleOption, topAlign } = props;

	const isMobile = useMediaQuery("(max-width: 768px)");

	if (invisibleOption && !text) return null;

	const getContent = () => {
		if (link) {
			const href = text && !text.startsWith('http://') && !text.startsWith('https://')
				? `https://${text}` 
				: text;
			
			return (
				<>
					<a
						className="link"
						style={{
							color: "var(--card-bg)",
						}}
						target={"_blank"}
						href={href}
						rel="noreferrer"
					>
						{text}
					</a>
				</>
			);
		}

		// notChip이 true이고 내부 협업 가능 인력이 아닌 경우 불릿 포인트 처리
		if (notChip && title !== "내부 협업 가능 인력") {
			const processedText = text?.split('\n').map((line, index) => {
				if (line.trim().startsWith('-')) {
					return (
						<div key={index} style={{ 
							display: 'flex', 
							alignItems: 'flex-start', 
							marginBottom: '8px',
							lineHeight: '1.5'
						}}>
							<span style={{ 
								marginRight: '8px', 
								marginTop: '1px',
								color: '#666',
								fontSize: '14px',
								fontWeight: 'bold'
							}}>•</span>
							<span style={{ flex: 1 }}>{line.trim().substring(1).trim()}</span>
						</div>
					);
				}
				return line ? (
					<div key={index} style={{ 
						marginBottom: '8px',
						lineHeight: '1.5'
					}}>{line}</div>
				) : <br key={index} />;
			});
			return <div style={{ width: '100%' }}>{processedText}</div>;
		}

		return (
			<>
				{!notChip
					? <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
						{text &&
						  text.split(",").map((t, i) => (
								<Chip
									sx={{
										color: "var(--primary-darken)",
										backgroundColor: "#f0f4ff",
										borderRadius: "6px",
										border: "none",
										fontSize: "13px",
										fontWeight: 500,
										height: "auto",
										"& .MuiChip-label": {
											padding: "5px 10px",
										},
									}}
									className="chip"
									key={i}
									label={t}
								/>
						  ))}
					  </div>
					: text}
			</>
		);
	};
	return (
		<ListItemContainer>
			<div className={"header"}>{title}</div>
			<div className="contents">{getContent()}</div>
		</ListItemContainer>
	);
};

export default ProfileListItem;

const ListItemContainer = styled.li`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	font-size: 14px;
	margin-bottom: 12px;

	.header {
		padding: 8px 0;
		flex-grow: 0;
		flex-shrink: 0;
		color: var(--card-bg);
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		white-space: pre-line;
		word-break: keep-all;
		width: 120px;
		flex-basis: 120px;

		@media screen and (max-width: 900px) {
			font-size: 13px;
			width: 100px;
			flex-basis: 100px;
		}
	}

	.contents {
		padding: 8px 14px;
		flex: 1;
		flex-shrink: 1;
		white-space: pre-wrap;
		word-break: break-all;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		color: var(--card-bg);
		flex-wrap: wrap;
		display: flex;
		flex-direction: column;
		border: 1px solid #E4E4E7;
		border-radius: 8px;
		background-color: var(--bg-white);
		min-height: 20px;

		@media screen and (max-width: 900px) {
			font-size: 13px;
			padding: 8px 12px;
		}
	}

	.chip * {
		@media screen and (max-width: 900px) {
			font-size: 13px;
		}
	}

	.contents > div {
		color: var(--card-bg);
		margin-right: 5px;
		margin-top: 4px;
		margin-bottom: 4px;
	}

	.link {
		color: -webkit-link;
		cursor: pointer;
		text-decoration: underline;
	}
`;
